/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type PublishJsonWebKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type PublishJsonWebKeyRequest = {
  /**
   * The ID of the key set to publish into.
   */
  setId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type PublishJsonWebKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PublishJsonWebKeySecurity$outboundSchema: z.ZodMiniType<
  PublishJsonWebKeySecurity$Outbound,
  PublishJsonWebKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function publishJsonWebKeySecurityToJSON(
  publishJsonWebKeySecurity: PublishJsonWebKeySecurity,
): string {
  return JSON.stringify(
    PublishJsonWebKeySecurity$outboundSchema.parse(publishJsonWebKeySecurity),
  );
}

/** @internal */
export type PublishJsonWebKeyRequest$Outbound = {
  set_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const PublishJsonWebKeyRequest$outboundSchema: z.ZodMiniType<
  PublishJsonWebKeyRequest$Outbound,
  PublishJsonWebKeyRequest
> = z.pipe(
  z.object({
    setId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      setId: "set_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function publishJsonWebKeyRequestToJSON(
  publishJsonWebKeyRequest: PublishJsonWebKeyRequest,
): string {
  return JSON.stringify(
    PublishJsonWebKeyRequest$outboundSchema.parse(publishJsonWebKeyRequest),
  );
}
